import { Link } from "react-router-dom";
import { Image } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import CloseButton from "./CloseButton/CloseButton";
import MainHeader from "./MainHeader/MainHeader";

const Header = () => {
  return (
    <header className="page-header row">
      <div className="logo-wrapper d-flex align-items-center col-auto">
        <Link to={`${process.env.PUBLIC_URL}/`}>
          {/* <Image className="for-light" src={dynamicImage("logo/logo.png")} alt="logo" /> */}
          <Image className="for-light" src={dynamicImage("logo/Truesales.png")} alt="logo" style={{height:50,marginTop:-10}}/>
          {/* <Image className="for-dark" src={dynamicImage("logo/dark-logo.png")} alt="logo" /> */}
          <Image className="for-dark" src={dynamicImage("logo/Truesales.png")} alt="logo" style={{height:50,marginTop:-10}}/>
        </Link>
        <CloseButton />
      </div>
      <MainHeader />
    </header>
  );
};

export default Header;
